import React, { Component } from "react";
import facebook from "../../../assets/images/facebook.svg";
import twitter from "../../../assets/images/twitter.svg";
import youtube from "../../../assets/images/youtube.svg";
import insta from "../../../assets/icons/instagram.svg";
import bip from "../../../assets/images/bip.png";
import orlen from "../../../assets/images/orlen_the_latest.svg";
import PZU from "../../../assets/images/pzu.svg";
import PKO from "../../../assets/images/pko.svg";
import Lexus from "../../../assets/images/Lexus.png";
import emitel from "../../../assets/images/nowe_logo_firmy_emitel.png";
import totalizator from "../../../assets/images/totalizator.svg";
import chopinFooter1_PL from "../../../assets/images/chopin-footer-1-pl.png";
import chopinFooter1_EN from "../../../assets/images/chopin-footer-1-en.png";
import chopinFooter2_PL from "../../../assets/images/chopin-footer-2-pl.png";
import chopinFooter2_EN from "../../../assets/images/chopin-footer-2-en.png";
import chopinFooter3_PL from "../../../assets/images/chopin-footer-3-pl.png";
import chopinFooter3_EN from "../../../assets/images/chopin-footer-3-en.png";
import chopinFooter4_PL from "../../../assets/images/chopin-footer-4-pl.svg";
import chopinFooter4_EN from "../../../assets/images/chopin-footer-4-en.svg";
import lot_EN from "../../../assets/images/lot-en.jpg";
import lot_PL from "../../../assets/images/lot-pl.jpg";
import okecie_PL from "../../../assets/images/chopin_airport_logo_PL.png";
import okecie_EN from "../../../assets/images/chopin_airport_logo_EN.png";
import mkidn_logo from "../../../assets/images/mkidn.webp";

export default class Bottom extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: props.data,
            config: props.config,
            cookiesAccepted: JSON.parse(window.localStorage.getItem("cookiesAccepted")) || false,
            cookieOptions: JSON.parse(window.localStorage.getItem("cookieOptions")) || {
                essential: true,
                analytics: true,
                marketing: true
            }
        };
    }

    componentDidMount() {
        document.documentElement.style.setProperty('--dynamic-bg-color', '#' + this.state.config.gbcolor);
    }

    handleCookieChange = (option) => {
        this.setState(prevState => {
            const newOptions = {
                ...prevState.cookieOptions,
                [option]: !prevState.cookieOptions[option]
            };
            window.localStorage.setItem("cookieOptions", JSON.stringify(newOptions));
            return { cookieOptions: newOptions };
        });
    }

    closeCookiesHandler = (acceptanceType) => {
        let options = {
            ...this.state.cookieOptions,
            essential: true
        };
        const currentDomain = window.location.hostname;

        if (acceptanceType === 'acceptAll') {
            options = {
                essential: true,
                analytics: true,
                marketing: true
            };
        } else if (acceptanceType === 'essentialOnly') {
            options = {
                essential: true,
                analytics: false,
                marketing: false
            };
        }

        this.setState({ cookieOptions: options, cookiesAccepted: options });
        window.localStorage.setItem("cookiesAccepted", JSON.stringify(options));
        window.localStorage.setItem("cookieOptions", JSON.stringify(options));

        let cookieDomain = '';
        if (currentDomain === 'nifc.pl' || currentDomain.slice(-8) === '.nifc.pl') {
            cookieDomain = '; domain=nifc.pl';
        } else if (currentDomain === 'iccpi.pl' || currentDomain.slice(-9) === '.iccpi.pl') {
            cookieDomain = '; domain=iccpi.pl';
        }
        document.cookie = `cookie=accepted; max-age=${30 * 24 * 60 * 60}${cookieDomain}; path=/; SameSite=Lax`;

        if (typeof window.applyCookieConsent === 'function') {
            window.applyCookieConsent(options);
        }

        const container = document.getElementById("cookie-container");
        container.style.opacity = "0";
        setTimeout(() => {
            container.remove();
        }, 3000);
    };

    render() {
        // console.log("Footer - Bottom props: ", this.props.data);
        let patronLabel = window.location.href.indexOf("/en/") > -1 ? "Patron" : "Mecenas";
        let patron2Label = window.location.href.indexOf("/en/") > -1 ? "Main Partner" : "Partner główny";
        let patron3Label = window.location.href.indexOf("/en/") > -1 ? "Strategic Partner" : "Partner Strategiczny";
        let patron4Label = window.location.href.indexOf("/en/") > -1 ? "Partners" : "Partnerzy";
        let patron5Label = window.location.href.indexOf("/en/") > -1 ? "Official carrier" : "Oficjalny przewoźnik";
        let patron6Label = window.location.href.indexOf("/en/") > -1 ? "Gold partner" : "Partner złoty";
        let patron7Label = window.location.href.indexOf("/en/") > -1 ? "Co-financed by the Ministry Of Culture And National Heritage" : "Dofinansowano ze środków Ministra Kultury i Dziedzictwa Narodowego";
        let closeLabel = window.location.href.indexOf("/en/") > -1 ? "Close" : "Zamknij";
        const year = new Date().getFullYear();

        const cookiesAccepted = JSON.parse(window.localStorage.getItem('cookiesAccepted'));
        const showCookieContainer = document.cookie.indexOf("cookie=accepted") === -1 && !cookiesAccepted;

        const { cookieOptions } = this.state;

        const style = {

            "backgroundColor": '#' + this.state.config.gbcolor

        };

        /*const hideModal = (event) => {
            window.sessionStorage.setItem("modal", true);
            document.getElementById("modalMuzeumBackground").classList.add("modalMuzeumBackgroundHidden")
            document.getElementById("modalMuzeumWrapper").classList.add("modalMuzeumWrapperHidden")
        }*/

        const cookieContainer = showCookieContainer ? (
            <div id="cookie-container">
                <div>
                    {window.location.href.indexOf("/en/") > -1 ? (
                        <div className="cookie-wrapper">
                            <p className="text">
                                <span>This website uses cookies. Using the site without changing your browser settings means that they will be placed on your device. By closing the window, you accept </span>
                                <strong>
                                    <a href="https://storage.nifc.pl/web_files/_files/Ochrona_danych_osobowych.pdf" target="_blank">
                                        the privacy policy and cookies.
                                    </a>
                                </strong>
                            </p>
                            <div className="row row1">
                                <div className="checkbox row2">
                                    <input id="cookieOption1" type="checkbox" className="slideCheckbox" disabled checked />
                                    <label htmlFor="cookieOption1" className="text label">Essential cookies</label>
                                </div>
                                <div className="checkbox row2">
                                    <input id="cookieOption2" type="checkbox" className="slideCheckbox" checked={cookieOptions.analytics} onChange={() => this.handleCookieChange('analytics')} />
                                    <label htmlFor="cookieOption2" className="text label clickable">Analytical cookies</label>
                                </div>
                                <div className="checkbox row2">
                                    <input id="cookieOption3" type="checkbox" className="slideCheckbox" checked={cookieOptions.marketing} onChange={() => this.handleCookieChange('marketing')} />
                                    <label htmlFor="cookieOption3" className="text label clickable">Marketing cookies</label>
                                </div>
                            </div>
                            <div className="row row3">
                                <button className="btnCookieAccept" onClick={() => this.closeCookiesHandler('essentialOnly')}>Essential cookies</button>
                                <button className="btnCookieAccept" onClick={() => this.closeCookiesHandler('selected')}>Confirm selected</button>
                                <button style={style} className="btnCookieAccept btnCta" onClick={() => this.closeCookiesHandler('acceptAll')}>Accept all</button>
                            </div>
                        </div>
                    ) : (
                        <div className="cookie-wrapper">
                            <p className="text">
                                <span>Ten serwis wykorzystuje pliki cookies. Korzystanie z witryny bez zmiany ustawień przeglądarki oznacza, że będą one umieszczane na Twoim urządzeniu. Zamknięcie okna oznacza akceptację </span>
                                <strong>
                                    <a href="https://storage.nifc.pl/web_files/_files/Ochrona_danych_osobowych.pdf" target="_blank">
                                        polityki prywatności i cookies.
                                    </a>
                                </strong>
                            </p>
                            <div className="row row1">
                                <div className="checkbox row2">
                                    <input id="cookieOption1" type="checkbox" className="slideCheckbox" disabled checked />
                                    <label htmlFor="cookieOption1" className="text label">Ciasteczka niezbędne</label>
                                </div>
                                <div className="checkbox row2">
                                    <input id="cookieOption2" type="checkbox" className="slideCheckbox" checked={cookieOptions.analytics} onChange={() => this.handleCookieChange('analytics')} />
                                    <label htmlFor="cookieOption2" className="text label clickable">Ciasteczka analityczne</label>
                                </div>
                                <div className="checkbox row2">
                                    <input id="cookieOption3" type="checkbox" className="slideCheckbox" checked={cookieOptions.marketing} onChange={() => this.handleCookieChange('marketing')} />
                                    <label htmlFor="cookieOption3" className="text label clickable">Ciasteczka marketingowe</label>
                                </div>
                            </div>
                            <div className="row row3">
                                <button className="btnCookieAccept" onClick={() => this.closeCookiesHandler('essentialOnly')}>Tylko niezbędne</button>
                                <button className="btnCookieAccept" onClick={() => this.closeCookiesHandler('selected')}>Potwierdź wybrane</button>
                                <button style={style} className="btnCookieAccept btnCta" onClick={() => this.closeCookiesHandler('acceptAll')}>Zaakceptuj wszystkie</button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        ) : null;
        /*
        const modal = !window.sessionStorage.getItem("modal") && this.props.config.bottom_component_endpoint.split("/")[2] === "api-muzeum.nifc.pl"  ? (
            <div>
                <div id="modalMuzeumBackground" className="modalMuzeumBackground" />
                <div id="modalMuzeumWrapper" className="modalMuzeumWrapper" onClick={hideModal}>
                    <div className="modalMuzeumContainer">
                        <div className="modalMuzeum">
                            <div className="closeMuzeum" onClick={hideModal}/>
                            <div className="modalMuzeumContent"/>
                        </div>
                    </div>
                </div>
            </div>
        ) : null
*/
        return (
            <section className="footer_bottom">
                <div className="footerinfo-block">
                    <div className="container">
                        <div className="row">
                            <div className="footerinfobl-wrap" style={{ display: "flex", flexFlow: "column" }}>
                                <div className="col-xs-12 col-sm-12 col-md-5 col-lg-6" style={{ width: "100%", paddingBottom: "20px" }}>
                                    <div className="chopin-footer">
                                        <div className="chopin-footer--content">
                                            <div>{window.location.href.indexOf("/en/") > -1 ? <img src={chopinFooter1_EN} alt="" /> : <img src={chopinFooter1_PL} alt="" />}</div>
                                            <div>{window.location.href.indexOf("/en/") > -1 ? <img src={chopinFooter2_EN} alt="" /> : <img src={chopinFooter2_PL} alt="" />}</div>
                                            <div>{window.location.href.indexOf("/en/") > -1 ? <img src={chopinFooter3_EN} alt="" /> : <img src={chopinFooter3_PL} alt="" />}</div>
                                            <div>{window.location.href.indexOf("/en/") > -1 ? <img src={chopinFooter4_EN} alt="" /> : <img src={chopinFooter4_PL} alt="" />}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="wrapperFooter" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <div className="copyrightWrapper">
                                        <p className="ftinfo-bl-copyright">&copy; Narodowy Instytut Fryderyka Chopina {year}</p>
                                    </div>
                                    <div className="footersocilaWrapper">
                                        <div className="footersocila-wrapper">
                                            <div className="bottomFooterWrapper">
                                                <ul className="fr-inflsholder footer-media-wrapper footer-media-wrapperBottom">
                                                    <li className="custom-mobile-divider"></li>

                                                    <li className="footer-socilamedia footer-mecenas mobile-no-padding"
                                                        style={{ verticalAlign: "middle" }}>
                                                        <div style={{ maxWidth: "230px" }}>
                                                            {patron7Label}
                                                            <a target="_blank" href="https://www.gov.pl/web/kultura">
                                                                <img src={mkidn_logo} alt="mkidn" />
                                                            </a>
                                                        </div>
                                                    </li>

                                                    <li className="footer-socilamedia footer-mecenas mobile-no-padding"
                                                        style={{ verticalAlign: "middle" }}>
                                                        <div>
                                                            {patronLabel}
                                                            <a target="_blank" href="https://www.orlen.pl/">
                                                                <img src={orlen} alt="orlen" />
                                                            </a>
                                                        </div>
                                                    </li>
                                                    <li className="custom-mobile-divider"></li>

                                                    <li className="footer-socilamedia footer-partner mobile-no-padding"
                                                        style={{ verticalAlign: "middle" }}>
                                                        <div>
                                                            {patron3Label}
                                                            <a target="_blank" href="https://www.pkobp.pl/">
                                                                <img style={{ height: "60px" }} src={PKO} alt="PKO" />
                                                            </a>
                                                        </div>
                                                    </li>
                                                    <li className="custom-mobile-divider"></li>

                                                    <li className="footer-socilamedia footer-partner mobile-no-padding"
                                                        style={{ verticalAlign: "middle" }}>
                                                        <div>
                                                            {patron2Label}
                                                            <a target="_blank" href="https://www.lotto.pl/">
                                                                <img style={{ height: "55px" }} src={totalizator}
                                                                    alt="lotto" />
                                                            </a>
                                                        </div>
                                                    </li>

                                                    <li className="custom-mobile-divider"></li>

                                                    <li className="footer-socilamedia footer-partner mobile-no-padding"
                                                        style={{ verticalAlign: "middle" }}>
                                                        <div>
                                                            {patron6Label}
                                                            <a target="_blank" href="https://www.pzu.pl/">
                                                                <img style={{ height: "50px" }} src={PZU} alt="PZU" />
                                                            </a>
                                                        </div>
                                                    </li>
                                                    <div className="separator"></div>
                                                    <li className="custom-mobile-divider"></li>

                                                    <li className="footer-socilamedia footer-partner mobile-no-padding"
                                                        style={{ verticalAlign: "middle" }}>
                                                        <div>
                                                            <span style={{ marginBottom: "20px", display: "flex" }}>{patron4Label}</span>
                                                            <a target="_blank" href="https://www.lexus-polska.pl/">
                                                                <img style={{ height: "33px", width: "120px" }} src={Lexus} alt="Lexus" />
                                                            </a>
                                                        </div>
                                                    </li>

                                                    <li className="custom-mobile-divider"></li>

                                                    <li className="footer-socilamedia mobile-no-padding mobile-super" style={{ verticalAlign: "middle" }}>
                                                        <a
                                                            target="_blank"
                                                            href={window.location.href.indexOf("/en/") > -1
                                                                ? "https://www.lotnisko-chopina.pl/en/index.html"
                                                                : "https://www.lotnisko-chopina.pl/pl/index.html"}
                                                        >
                                                            <img
                                                                src={window.location.href.indexOf("/en/") > -1 ? okecie_EN : okecie_PL}
                                                                alt="okecie"
                                                                style={{ height: "65px", width: "auto" }}
                                                            />

                                                        </a>
                                                    </li>



                                                    <li className="custom-mobile-divider"></li>

                                                    <li className="footer-socilamedia mobile-no-padding mobile-super"
                                                        style={{ verticalAlign: "middle" }}>
                                                        <a target="_blank" href="https://emitel.pl/">
                                                            <img style={{ height: "50px" }} src={emitel} alt="emitel" />
                                                        </a>
                                                    </li>

                                                    <div className="separator"></div>
                                                    <li className="custom-mobile-divider"></li>

                                                    <li className="footer-socilamedia footer-partner mobile-no-padding"
                                                        style={{ verticalAlign: "middle" }}>
                                                        <div>
                                                            {patron5Label}
                                                            <a target="_blank"
                                                                href={`${window.location.href.indexOf("/en/") > -1 ? "https://www.lot.com/pl/en" : "https://www.lot.com/pl/pl"}`}>
                                                                <img
                                                                    src={`${window.location.href.indexOf("/en/") > -1 ? lot_EN : lot_PL}`}
                                                                    style={{ height: "55px" }} alt="lot" />
                                                            </a>
                                                        </div>
                                                    </li>
                                                    <li className="custom-mobile-divider"></li>
                                                    <li className="footer-socilamedia mobile-no-padding mobile-super-2"
                                                        style={{ verticalAlign: "middle" }}>
                                                        <a target="_blank" href="http://bip.nifc.pl">
                                                            <img src={bip} alt="bip" />
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {cookieContainer}
                {/*modal*/}
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Footer/Bottom/index.js